<template>
  <vs-row>
    <b-loading :is-full-page="true" v-model="isLoading"/>
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-card style="border-radius: 10px;">

        <b-modal
            v-model="isCardModalActive"
            :width="850"
            scroll="keep"
            :on-cancel="onCancelModalEmailPhone"
        >
          <div class="modal-card" style="width: auto">
            <header class="modal-card-head header-modal">
              <p class="modal-card-title" style="color: white">
                <i class="mr-2 mdi mdi-email"></i
                >{{
                  modalPhone
                      ? "Agregar Teléfonos"
                      : "Agregar Correos Electrónicos"
                }}
              </p>
            </header>
            <section class="modal-card-body" v-if="!modalPhone">
              <vs-alert
                  title="Error"
                  :active="errorsModal.show"
                  color="danger"
                  class="mb-3"
              >
                {{ errorsModal.message }}
              </vs-alert>
              <div
                  class="columns pl-3 pr-3 pt-3 pb-3"
                  v-if="emails == null || emails.length === 0"
              >
                <b-button type="is-info" @click="addNewEmail()"
                ><i class="mdi mdi-plus"></i> Agregar correo
                </b-button
                >
              </div>
              <div class="columns" v-for="(email, index) in emails" :key="index">
                <div class="column">
                  <b-field label="Correo:">
                    <b-input
                        expanded
                        type="email"
                        :value="email.email"
                        v-model="email.email"
                        required
                    >
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Tipo:">
                    <b-select
                        placeholder="Seleccione un tipo de correo"
                        v-model="email.type"
                        expanded
                    >
                      <option
                          v-for="option in emailTypes"
                          :value="option.id"
                          :key="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div class="column is-one-fifth">
                  <b-button
                      v-if="email.add"
                      type="is-info"
                      class="modal-button-custom"
                      @click="addNewEmail()"
                  ><i class="mdi mdi-plus"></i
                  ></b-button>
                  <b-button
                      type="is-danger"
                      class="modal-button-custom"
                      @click="deleteEmail(index)"
                  ><i class="mdi mdi-minus"></i
                  ></b-button>
                </div>
              </div>
            </section>
            <section class="modal-card-body" v-else>
              <vs-alert
                  title="Danger"
                  :active="errorsModal.show"
                  color="danger"
                  class="mb-3"
              >
                {{ errorsModal.message }}
              </vs-alert>
              <div
                  class="columns pl-3 pr-3 pt-3 pb-3"
                  v-if="phones == null || phones.length === 0"
              >
                <b-button type="is-info" @click="addNewPhone()"
                ><i class="mdi mdi-plus"></i> Agregar teléfono
                </b-button
                >
              </div>
              <div class="columns" v-for="(phone, index) in phones" :key="index">
                <div class="column">
                  <b-field label="Teléfono:">
                    <b-input
                        expanded
                        type="text"
                        v-validate="'required|numeric'"
                        :value="phone.phone"
                        v-model="phone.phone"
                        required
                    >
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Tipo:">
                    <b-select
                        placeholder="Seleccione un tipo de teléfono"
                        v-model="phone.type"
                        expanded
                    >
                      <option
                          v-for="option in emailTypes"
                          :value="option.id"
                          :key="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div class="column is-one-fifth">
                  <b-button
                      v-if="phone.add"
                      type="is-info"
                      class="modal-button-custom"
                      @click="addNewPhone()"
                  ><i class="mdi mdi-plus"></i
                  ></b-button>
                  <b-button
                      type="is-danger"
                      class="modal-button-custom"
                      @click="deletePhone(index)"
                  ><i class="mdi mdi-minus"></i
                  ></b-button>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <b-button
                  type="is-info"
                  label="Aceptar"
                  @click="modalPhone ? acceptNewPhones() : acceptNewEmails()"
              />
              <b-button
                  type="is-danger"
                  label="Cancelar"
                  @click="modalPhone ? deletePhones() : deleteEmails()"
              />
            </footer>
          </div>
        </b-modal>
        <fieldset class="fieldset pb-4">
          <legend>Datos básicos</legend>
          <div class="columns">
            <div class="column is-4">
              <b-field label="Tipo de persona *">
                <b-select
                    placeholder="Seleccione una opción"
                    expanded
                    v-model="entityType"
                    name="entityType"
                    v-validate="'required'"
                >
                  <option
                      v-for="option in entityTypes"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                  >
                    {{ option.title }}
                  </option>
                </b-select>
              </b-field>
              <span class="show-error">{{ errors.first("entityType") }}</span>
            </div>
            <div class="column is-4" v-if="entityType">
              <b-field label="Regimen *">
                <b-select
                    placeholder="Seleccione una opción"
                    expanded
                    v-model="regime"
                    name="regime"
                    v-validate="'required'"
                >
                  <option
                      v-for="option in regimensList"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                  >
                    {{ option.title }}
                  </option>
                </b-select>
              </b-field>
              <span class="show-error">{{ errors.first("regime") }}</span>
            </div>
          </div>
          <div class="columns" v-if="entityType">
            <div class="column">
              <b-field label="Tipo identificación *">
                <b-select
                    placeholder="Seleccione una opción"
                    expanded
                    v-model="identificationType"
                    name="identificationType"
                    v-validate="'required'"
                >
                  <option
                      v-for="option in identificationTypes"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                  >
                    {{ option.title }}
                  </option>
                </b-select>
              </b-field>
              <span class="show-error">{{
                  errors.first("identificationType")
                }}</span>
            </div>
            <div class="column" v-if="entityType">
              <b-field label="Identificación *">
                <b-input
                    placeholder="Identificación"
                    type="text"
                    name="identification"
                    v-model="identification"
                    @blur="onBlurIdentification"
                    v-validate="'required|numeric'"
                    icon-right="magnify"
                    icon-right-clickable
                    @icon-right-click="onBlurIdentification()"
                />
              </b-field>
              <span class="show-error">{{ errors.first("identification") }}</span>
            </div>
            <div class="column" v-if="entityType">
              <b-field label="Nombre completo">
                <b-input
                    class="uppercase"
                    placeholder="Nombre del tercero"
                    type="text"
                    name="name"
                    v-model="name"
                    v-validate="'required'"
                />
              </b-field>
              <span class="show-error">{{ errors.first("name") }}</span>
            </div>
          </div>
          <div class="columns" v-if="entityType">
            <div class="column">
              <b-field label="Teléfonos">
                <b-input
                    v-validate="'required'"
                    placeholder="Teléfono"
                    type="text"
                    name="phone"
                    :value="phone"
                    disabled
                    expanded
                ></b-input>
                <b-button
                    class="button is-info is-light"
                    @click="openModal('phone')"
                ><i class="mr-2 mdi mdi-tooltip-edit"></i
                ></b-button>
              </b-field>
              <span class="show-error">{{ errors.first("phone") }}</span>
            </div>
            <div class="column">
              <b-field label="Correos electrónicos">
                <b-input
                    placeholder="Correos electrónicos"
                    type="text"
                    disabled
                    expanded
                    name="email"
                    v-validate="'required'"
                    :value="email"
                ></b-input>
                <b-button class="button is-info is-light" @click="openModal()"
                ><i class="mr-2 mdi mdi-tooltip-edit"></i
                ></b-button>
              </b-field>
              <span class="show-error">{{ errors.first("email") }}</span>
            </div>
            <div class="column is-4">
              <b-field label="Responsable fiscal *">
                <b-select
                    placeholder="Seleccione una opción"
                    expanded
                    v-model="fiscalResponsibility"
                    name="fiscalResponsibility"
                    v-validate="'required'"
                >
                  <option
                      v-for="option in fiscalList"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                  >
                    {{ option.title }}
                  </option>
                </b-select>
              </b-field>
              <span class="show-error">{{
                  errors.first("fiscalResponsibility")
                }}</span>
            </div>
          </div>
        </fieldset>
        <fieldset class="fieldset pb-4" v-if="entityType && !isGeneric()">
          <legend>Nacionalidad y Ubicación</legend>
          <div class="columns">
            <div :key="forceRender" class="column is-4 location-component">
              <b-field label="Ciudad *">
                <vs-select class="w-100 mb-4 vs-input-large selector"
                           autocomplete
                           v-model="city"
                           placeholder="Seleccione la ciudad"
                           tabindex=10>
                  <vs-select-item
                      :key="index"
                      :value="item.code"
                      :text="item.title"
                      v-for="(item, index) in cities"/>
                </vs-select>
              </b-field>
              <span class="show-error">{{ errors.first("city") }}</span>
            </div>
            <div class="column is-4">
              <b-field label="Código postal *">
                <b-input
                    placeholder="Código postal"
                    type="text"
                    name="zipCode"
                    v-model="zipCode"
                    v-validate="'required|numeric'"
                />
              </b-field>
              <span class="show-error">{{ errors.first("zipCode") }}</span>
            </div>
            <div class="column">
              <b-field label="Dirección *">
                <b-input
                    placeholder="Dirección"
                    type="text"
                    name="address"
                    v-model="address"
                    v-validate="'required'"
                />
              </b-field>
              <span class="show-error">{{ errors.first("address") }}</span>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field label="Indicaciones">
                <b-input
                    placeholder="Indicaciones"
                    type="textarea"
                    rows="3"
                    name="indications"
                    v-model="indications"
                />
              </b-field>
              <span class="show-error">{{ errors.first("indications") }}</span>
            </div>
          </div>
        </fieldset>
        <div class="columns" v-if="entityType">
          <div class="column">
            <div class="columns">
              <div class="column">
                <vs-button
                    color="primary"
                    icon="save"
                    class="pl-5 pr-5"
                    type="filled"
                    @click="save()"
                >
                  Guardar
                </vs-button>
              </div>
              <div class="col-12">
                <vs-button
                    color="dark"
                    icon="close"
                    class="pl-5 pr-5 ml-3"
                    type="filled"
                    @click="cancel()"
                    style="margin-top: 11px;"
                >
                  Cancelar
                </vs-button>
              </div>
            </div>
          </div>
        </div>
        <b-loading :is-full-page="true" v-model="isLoading"></b-loading>

      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import {ROUTES} from "@/global/api_routes";
import {configToast, TOAST_TYPES} from "@/global/toast";
import {get as getProp} from "object-path";
import Styles from "./styles";
import Autocomplete from "@/components/Shared/Autocomplete";
import {entityType} from "@/global/constants";
import EKind from "@/global/lasting/EKind";
import LocationEndpoint from "@/endpoints/core/LocationEndpoint";

export default {
  name: "UserRegister",
  components: {Styles, Autocomplete},
  props: ["entityCode"],
  data: () => ({
    forceRender: 0,
    actualCode: null,
    isLoading: false,
    city: null,
    name: null,
    companies: null,
    phone: null,
    email: null,
    regime: null,
    identification: null,
    company: null,
    indications: null,
    zipCode: null,
    address: null,
    identificationType: null,
    regimeList: null,
    entityType: null,
    entityTypes: null,
    fiscal: null,
    country: null,
    location: null,
    countriesList: null,
    editModal: false,
    fiscalResponsibility: null,
    selectedEdit: null,
    searchModal: null,
    tempLocation: null,
    hackFill: 0,
    hideLoader: false,
    usersEditList: [],
    regimensList: [],
    identificationTypes: [],
    fiscalList: [],
    locationList: [],
    cities: [],
    emails: [],
    phones: [],
    originalCities: [],
    emailTypes: [
      {name: "Personal", id: "P"},
      {name: "Trabajo", id: "W"},
      {name: "Otro", id: "O"},
    ],
    extraInfo: [
      {
        title: null,
        value: null,
        order: null,
        type: null,
        add: true,
      },
    ],
    isCardModalActive: false,
    modalPhone: false,
    modalInfo: false,
    extraInfoEditing: null,
    errorsModal: {
      message: "",
      show: false,
    },
    errorsModalInfo: {
      message: "",
      show: false,
    },
  }),
  watch: {
    entityType: async function () {
      if (!this.entityType) {
        return;
      }
      this.isLoading = true;
      await this.getComboxList();
      this.checkGenericUser();
    },
    city: function () {
      if (!this.city) {
        return;
      }
      this.autoCompleteZipCode();
    },
  },
  mounted() {
    this.initQueries(this.entityCode);
  },
  methods: {
    parseJsonData(objString) {
      try {
        return JSON.parse(objString);
      } catch (error) {
        return [];
      }
    },
    fillData(data) {
      this.actualCode = data.code;
      this.entityType = getProp(data, "entityType.code");
      if (Object.keys(data.entityType).length === 0) {
        this.entityType = entityType.NATURAL_PERSON;
      }
      this.regime = getProp(data, "regime.code");
      this.identificationType = getProp(data, "identificationType.code");
      this.identification = getProp(data, "identification");
      this.name = getProp(data, "name");
      this.phones = this.parseJsonData(getProp(data, "telephone"));
      this.emails = this.parseJsonData(getProp(data, "email"));
      this.phone = `${this.phones.length} seleccionados`;
      this.email = `${this.emails.length} seleccionados`;
      this.fiscalResponsibility = getProp(data, "fiscalResponsibility.code");
      this.zipCode = data.zipCode;
      this.indications = data.indications;
      this.address = data.address;
      const location = data.location;
      if (location != null && Object.keys(location).length > 0) {
        this.city = location.code;
      }
      this.forceRender++;
    },
    findUser(code) {
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.USERS.GET_USER_BY_CODE, {
            params: {
              userCode: code,
            },
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.fillData(data.info);
              return;
            }
            this.toast(data.message, TOAST_TYPES.ERROR);
          })
          .finally(() => {
            if (this.hideLoader) {
              this.isLoading = false;
            }
            this.forceRender++;
          });
    },
    getCities({action, searchQuery, callback}) {
      if (action === "ASYNC_SEARCH") {
        if (searchQuery.length < 2) {
          return;
        }
        this.$http
            .get(ROUTES.GLOBAL.GET_CITIES, {
              params: {
                search: searchQuery,
              }
            })
            .then(({data}) => {
              if (data.code > 0) {
                this.cities = data.info;
                this.originalCities = [...data.info];
                this.processData(this.cities);
                this.cities = this.groupCities(this.cities);
                callback(null, this.cities);
              } else {
                this.cities = [];
                callback(null, []);
              }
            });
      }
    },
    cancel() {
      if (this.actualCode > 0) {
        this.$router.push("/view/users/entities/list");
        return;
      }
      this.cleanForm();
    },
    onBlurIdentification() {
      if (this.identification.trim() === "") {
        return;
      }
      this.findUserByIdentification();
    },
    checkGenericUser() {
      const entityType = this.entityTypes.find(
          (item) => item.code == this.entityType
      );
      if (!entityType || entityType.initials !== "GE") {
        return;
      }
      this.regime = getProp(this.regimensList, "0.code");
      this.identificationType = getProp(this.identificationTypes, "0.code");
      this.fiscalResponsibility = getProp(this.fiscalList, "0.code");
      this.identification = "111";
      this.name = "GENERIC";
      this.phone = "0000000";
      this.email = "generic-user@accesspark.com";
    },
    isGeneric() {
      const entityType = this.entityTypes.find(
          (item) => item.code == this.entityType
      );

      return getProp(entityType, "initials") === "GE";
    },
    onCancelModalEmailPhone() {
      if (this.modalPhone) {
        this.modalPhone = false;
      }
      this.errorsModal.show = false;
      this.errorsModal.message = "";
      this.isCardModalActive = false;
    },
    getIdentificationTypeInitials() {
      const id = this.identificationType;
      const identificationType = this.identificationTypes.find(item => item.code === id);
      return getProp(identificationType, 'initials', 'CC');
    },
    findUserByIdentification() {
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.USERS.GET_USER_BY_IDENTIFICATION, {
            params: {
              identification: this.identification,
              identificationType: this.getIdentificationTypeInitials()
            },
          })
          .then(({data}) => {
            if (data.code > 0) {
              const user = data.info;
              this.toast(
                  "Se ha encontrado un tercero con el número de identificación",
                  TOAST_TYPES.WARNING
              );
              this.fillData(user);
            }
          })
          .finally(() => {
            this.isLoading = false;
            this.forceRender++;
          });
    },
    async initQueries(codeUser) {
      this.isLoading = true;
      const cities = await LocationEndpoint.listProvincesAndCities();
      console.log("el await cities ==> ",cities);
      this.getListProvincesAndCities(cities);
      console.log("las ciudades ya ajustadas  ===> ", this.cities);
      const entityTypes = await this.getUnitiesByKind(EKind.CUSTOMER_TYPE);
      this.setList(entityTypes, "entityTypes");
      if (codeUser) {
        this.findUser(codeUser);
        this.isLoading = false;
        return;
      }
      this.isLoading = false;
    },
    autoCompleteZipCode() {
      if (this.originalCities.length === 0) {
        return;
      }
      const selectedCompany = this.originalCities.find(
          (item) => item.code === this.city
      );
      if (!selectedCompany) {
        return;
      }
      this.zipCode = selectedCompany.postalCode;
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#subscription_container");
      return instance.open(message, type);
    },
    openEditModal() {
      this.editModal = true;
      this.getListUsers();
    },
    openModal(type = null) {
      if (type === "info") {
        this.modalInfo = true;
        this.modalPhone = false;
        this.isCardModalActive = false;
        return;
      }
      if (type != null) {
        this.modalPhone = true;
        this.isCardModalActive = true;
        return;
      }
      this.modalPhone = false;
      this.isCardModalActive = true;
    },
    closeEditModal() {
      this.editModal = false;
    },
    getListUsers() {
      if (this.usersEditList.length > 0) {
        return;
      }
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.ENTITY.SEARCH_USERS, {
            params: {
              search: this.searchModal,
            }
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.usersEditList = data.info;
              return;
            }
            this.usersEditList = [];
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    cleanForm() {
      this.$validator.reset();
      this.company = null;
      this.identificationType = null;
      this.identification = null;
      this.name = null;
      this.phone = null;
      this.email = null;
      this.regime = null;
      this.entityType = null;
      this.fiscalResponsibility = null;
      this.location = null;
      this.zipCode = null;
      this.address = null;
      this.searchModal = null;
      this.actualCode = null;
      this.$router.replace({query: null});
    },
    save() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.toast("Complete el formulario", TOAST_TYPES.ERROR);
          return;
        }

        this.isLoading = true;
        this.$http
            .post(ROUTES.DASHBOARD.ENTITY.SAVE_ENTITY, {
              code: this.actualCode,
              name: this.name.toUpperCase(),
              identification: this.identification,
              identificationType: this.identificationType,
              telephone: JSON.stringify(this.phones),
              email: JSON.stringify(this.emails),
              address: this.address,
              regime: {code: this.regime},
              location: this.city,
              zipCode: this.zipCode,
              entityType: {code: this.entityType},
              indications: this.indications,
              fiscalResponsibility: {code: this.fiscalResponsibility},
            })
            .then(({data}) => {
              if (data.code > 0) {
                this.toast(
                    this.actualCode
                        ? "Se ha actualizado correctamente el tercero"
                        : "Se ha registrado correctamente el tercero",
                    TOAST_TYPES.SUCCESS
                );

                this.cleanForm();
                return;
              }
              this.toast(data.message, TOAST_TYPES.ERROR);
            })
            .finally(() => {
              this.isLoading = false;
            });
      });
    },
    setList(response, listName) {
      this[listName] = response.data.code > 0 ? response.data.info : [];
    },
    async getComboxList() {
      this.hideLoader = false;
      const companiesResponse = await this.getCompanies();
      this.setList(companiesResponse, "companies");
      this.processData(this.companies);
      //Listamos las ciudades...
      const identificationTypes = await this.getUnitiesByKind(
          EKind.IDENTIFICATION_TYPE,
          this.entityType
      );
      this.setList(identificationTypes, "identificationTypes");
      const regimensList = await this.getUnitiesByKind(EKind.USER_REGIME, this.entityType);
      this.setList(regimensList, "regimensList");
      const fiscalList = await this.getUnitiesByKind(EKind.FISCAL_RESPONSIBILITY, this.entityType);
      this.setList(fiscalList, "fiscalList");
      this.isLoading = false;
      this.hideLoader = true;
    },
    processData(companies) {
      for (let index = 0; index < companies.length; index++) {
        let company = companies[index];
        company.label = company.title ? company.title : company.name;
        company.id = company.code;
        if (company.children) {
          this.processData(company.children);
        }
      }
    },
    getUnitiesByKind(kindId, kindFather) {
      return this.$http.get(ROUTES.DASHBOARD.ENTITY.GET_LIST_BY_KIND, {
        params: {
          kindId,
          kindFather,
        }
      });
    },
    getCompanies() {
      return this.$http.get(ROUTES.DASHBOARD.GET_COMPANIES_TREE);
    },
    getLocations() {
      return this.$http.get(ROUTES.GLOBAL.GET_CITIES);
    },
    getChildCities(cities, city) {
      city.children = cities.filter(
          (item) => getProp(item, "father.code", item.father) == city.code
      );
      city.children.forEach((city) => {
        this.getChildCities(cities, city);
      });
    },
    addNewEmail() {
      if (this.emails.length === 1) {
        this.emails[0].add = false;
      }
      if (this.emails.length > 1) {
        this.emails[this.emails.length - 1].add = false;
      }
      this.emails = [
        ...this.emails,
        {
          email: "",
          type: "",
          add: true,
        },
      ];
    },
    addNewPhone() {
      if (this.phones.length === 1) {
        this.phones[0].add = false;
      }
      if (this.phones.length > 1) {
        this.phones[this.phones.length - 1].add = false;
      }
      this.phones = [
        ...this.phones,
        {
          phone: "",
          type: "",
          add: true,
        },
      ];
    },
    deletePhones() {
      this.phones = [
        {
          phone: "",
          type: "",
          add: true,
        },
      ];
      this.isCardModalActive = false;
      this.modalPhone = false;
      this.errorsModal.message = "";
      this.errorsModal.show = false;
      this.phone = "";
    },
    deleteEmail(index) {
      this.emails.splice(index, 1);
    },
    deletePhone(index) {
      this.phones.splice(index, 1);
    },
    acceptNewEmails() {
      for (let index = 0; index < this.emails.length; index++) {
        const email = this.emails[index];
        if (email.email === "") {
          this.errorsModal.message = "Debe ingresar todos los correos";
          this.errorsModal.show = true;
          return;
        }
        if (email.type === "") {
          this.errorsModal.message = "Debe ingresar todos los tipos de correo";
          this.errorsModal.show = true;
          return;
        }
      }
      this.errorsModal.message = "";
      this.errorsModal.show = false;
      if (this.emails.length === 1) {
        this.isCardModalActive = false;
        return (this.email = `Se Agrego 1 correo`);
      }
      this.email = `Se Agregaron (${this.emails.length}) correos`;
      this.isCardModalActive = false;
    },
    acceptNewPhones() {
      for (let index = 0; index < this.phones.length; index++) {
        const phone = this.phones[index];
        if (phone.phone === "") {
          this.errorsModal.message = "Debe ingresar todos los teléfonos";
          this.errorsModal.show = true;
          return;
        }
        if (phone.type === "") {
          this.errorsModal.message = "Debe ingresar todos los tipos de correo";
          this.errorsModal.show = true;
          return;
        }
      }
      this.errorsModal.message = "";
      this.errorsModal.show = false;
      if (this.phones.length === 1) {
        this.isCardModalActive = false;
        this.modalPhone = false;
        return (this.phone = `Se agregó 1 teléfono`);
      }
      this.phone = `Se agregaron (${this.phones.length}) teléfonos`;
      this.modalPhone = false;
      this.isCardModalActive = false;
    },
    groupCities(cities) {
      //Obtenemos los padres...
      const fathers = cities.filter(
          (item) => !getProp(item, "father.code", item.father)
      );
      fathers.forEach((city) => {
        //Buscamos los hijos de esto...
        this.getChildCities(cities, city);
      });
      return fathers;
    },
    getListProvincesAndCities(citiesList) {
      this.cities = citiesList.map(item => ({
        code: item.code,
        title: item.father.title + " - " +  item.title,
        postalCode: item.postalCode,
      }));
    },
  },

};
</script>
